module.exports = __webpack_public_path__ + "static/media/concept-energy-label-appp.e2dec336.svg";